export enum EOrderStatusGroup {
  NEW_REQUEST = 'NEW_REQUEST',
  DOCUMENTS_REGISTRATION = 'DOCUMENTS_REGISTRATION',
  PREPAYMENT = 'PREPAYMENT',
  SHIPMENT = 'SHIPMENT',
  PAYMENT = 'PAYMENT',
  COMPLETED = 'COMPLETED',
}
